import ClinicalDataComponent from './component';

const ClinicalDataContainer = () => {
  return <ClinicalDataComponent />;
};

export default ClinicalDataContainer;
